/**
 * 神策统计
 * @author fulh
 * @create 16/8/3.
 */
$.module('MM.util.sdata', function () {
  var _saData = {
    stay_stime: 0,
    view_stime: 0,
    stay_total: 0,
    view_total: 0,
  };

  var _isRegister = false;
  var isSent = false;

  var ID_PREFIX = 'W'; // 标示前缀

  var PAGE_PRESET = {
    // 页面预定义标示信息
    map: {
      // 正常 key: value 映射
      '/': '001',
    },
    reg: {
      // 需要正则匹配页面, 多个同时匹配，会匹配第一个
      '^/(\\d*)$': '002',
    },
  };

  /**
   * 神策注册公共字段
   */
  function registerSdata(options) {
    var userInfo = _.get(options, 'userInfo') || {};
    var userId = userInfo._id || '';

    // 每一个事件 会报的公共事件
    var saCommonFiled = {
      client_type:
        location.hostname.indexOf('union.imeme.tv') > -1 ||
        location.hostname.indexOf('union.2339.com') > -1
          ? 'PC_UNION'
          : 'PC',
      // 如果未登录 以下三个数据均为空字符串
      user_memeid: userId,
      channel: $.query.get('from') || MM.common.getCookie('from') || 'MM',
    };

    // 如果已经登录 更新标示
    if (userId) {
      sa.identify(userId);
    }

    sa.registerPage(saCommonFiled);

    if (!_isRegister) {
      _isRegister = true;
      // 设置之后，SDK就会自动收集页面浏览事件，
      sa.quick('autoTrack', _getPresetPageInfo());
    }
  }

  registerSdata();

  /**
   * 获取每个页面预定义标示信息
   * @returns {object}
   */
  function _getPresetPageInfo(referrer) {
    var currPageId = _getPresetPageId(location.href);
    // 使用神策SDK 获取来源页面 方法
    var prePageId = _getPresetPageId(referrer || sa._.getReferrer());

    var pageInfo = {
      page_number: !currPageId ? '' : ID_PREFIX + currPageId, // 浏览页面编号
      previous_page_number: !prePageId ? '' : ID_PREFIX + prePageId, // 前一页面编号
    };

    return pageInfo;
  }

  /**
   * 获取 $WebClick 事件参数
   * @param {HTMLElement} target 当前点击 元素
   * @param {object} props 神策默认上报的数据
   * @returns {object} 经过处理的 上报数据
   */
  function getSaWebClickProps(target, props) {
    var sawebclick = props.sawebclick
      ? props.sawebclick
      : $(target).parents('[data-sawebclick]').data('sawebclick') || '';

    if (!sawebclick) return;

    var webClick = MM.common.parseQueryString(sawebclick) || {};

    // 点击 按钮 需要的额外 参数
    var webClickProps = {
      $element_id: ID_PREFIX + webClick.id, // 点击按钮ID编号
      $element_content: webClick.text || props.$element_content, // 点击按钮文本信息
      display_contents_concretely:
        webClick.desc || webClick.text || props.$element_content, // 点击按钮核心数据
    };

    return _.assign({}, webClickProps);
  }

  /**
   * 获取页面预定义标示字段
   * @param {string} url 需要标示的页面urlstring
   * @returns {object} PAGE_PRESET所定义的页面数据信息
   */
  function _getPresetPageId(url) {
    if (!url || /^[\u4E00-\u9FA5]*$/.test(url)) return;

    // 使用 神策SDK 解析 url 的工具方法
    var URLParser = _.get(sa._.urlParse(url), '_values') || {};

    // 不是当前域的链接 不做处理
    if (URLParser.Hostname !== location.hostname) {
      return;
    }

    // 页面路径
    var pathname = URLParser.Path;

    // 简单匹配 路径名 规则， 是  [a-zA-Z0-9_] 与 '/' 组成的 字符串则通过
    if (!/\w|\//.test(pathname)) {
      return;
    }

    var result = undefined;

    // 匹配哈希与pathname
    _.map(PAGE_PRESET.hash, function (hashPageId, hashkey) {
      if (result) return;

      var hashPathObj = $.query.parseURL(hashkey);
      if (hashPathObj.pathname && hashPathObj.pathname != pathname) {
        return;
      }
      if (url.indexOf('#' + hashPathObj.anchor) > -1) {
        result = hashPageId;
      }
    });

    if (result) {
      return result;
    }

    // 直接pathname匹配 返回数据
    if (PAGE_PRESET.map[pathname]) {
      return PAGE_PRESET.map[pathname];
    }

    // 遍历需要正则匹配的页面
    _.map(PAGE_PRESET.reg, function (regPageId, reg) {
      if (result) return;

      if (new RegExp(reg).test(pathname)) {
        result = regPageId;
      }
    });

    return result;
  }

  /**
   * 获取 神策数据 上报的所有公共 数据字段
   * @returns {object} 神策公共数据字段
   */
  function getSaProperties() {
    var result = {};
    try {
      // 防止SDK 公共方法出错
      result = _.assign(
        {},
        sa._.info.properties(),
        sa.store.getProps(),
        sa.store.getSessionProps(),
        sa._.info.currentProps,
      );
    } catch (e) {
      MM.core.debug('sdata get Properties error', e);
    }

    return result;
  }

  function init(starId, starName) {
    MM.core.debug('sdata init', starId, starName);

    _startTime();

    _registerEvents();
  }

  function _registerEvents() {
    // $(window).blur(_updateTime);
    // $(window).focus(_startTime);
  }

  /**
   * 更新统计时间
   * @private
   */
  function _updateTime() {
    var nowTime = new Date().getTime();
    MM.core.debug('nowTime', nowTime);
    _saData.stay_total +=
      _saData.stay_stime > 0
        ? Math.floor((nowTime - _saData.stay_stime) / 1000 / 60)
        : 0;
    _saData.stay_total = _saData.stay_total > 0 ? _saData.stay_total : 0;
    _saData.stay_total = _saData.stay_total > 480 ? 480 : _saData.stay_total;
    _saData.stay_stime = 0;

    stopViewTime();
    MM.core.debug(
      '[stay===view]update',
      _saData.stay_total,
      _saData.view_total,
    );
  }

  function _startTime() {
    var nowTime = new Date().getTime();
    _saData.stay_stime = nowTime;
    startViewTime();
  }

  /**
   * 开始统计观看时长
   * @private
   */
  function startViewTime() {
    if (MM.live.room.isLive()) {
      _saData.view_stime = new Date().getTime();
    }
  }

  /**
   * 停止统计观看时长
   * @private
   */
  function stopViewTime() {
    var nowTime = new Date().getTime();
    _saData.view_total +=
      _saData.view_stime > 0
        ? Math.floor((nowTime - _saData.view_stime) / 1000 / 60)
        : 0;
    _saData.view_total = _saData.view_total > 0 ? _saData.view_total : 0;
    _saData.view_total = _saData.view_total > 480 ? 480 : _saData.view_total;
    _saData.view_stime = 0;
  }

  /**
   * 获取事件唯一ID
   * @param eventKey 事件标识
   * @param edi
   */
  function getEventSeqId(eventKey) {
    return new Date().valueOf() + '_' + eventKey + '_' + _.random(10000, 99999);
  }

  /**
   * 事件中添加唯一ID，并上报
   * @param eventKey 事件标识
   * @param data 事件数据
   * @return seqId
   */
  function trackWithSeqId(eventKey, data) {
    var seqId = getEventSeqId(eventKey);
    sa.track(eventKey, _.assign({ event_seq_id: seqId }, data));
    return seqId;
  }

  return {
    init: init,
    stopViewTime: stopViewTime,
    startViewTime: startViewTime,
    getEventSeqId: getEventSeqId,
    trackWithSeqId: trackWithSeqId,
    registerSdata: registerSdata,
    getSaWebClickProps: getSaWebClickProps,
    getSaProperties: getSaProperties,
  };
});
